module.exports = __webpack_public_path__ + "static/img/feature-3.57de02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-3.png
// module id = wjGY
// module chunks = 1